import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import React, { useEffect } from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import BasicMenu from "../../helpers/menu";
import FormDialog from "../../helpers/FormDialog";
import DeleteDialog from "../../helpers/DeleteDialog";
import {
  Avatar,
  CardActionArea,
  Checkbox,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  Switch,
  Typography,
} from "@mui/material";
import StyledBadge from "../../helpers/StyledBadge";
import { grey } from "@mui/material/colors";
import { downloadUrl } from "../../Shared/commonFunction";

function Technology({ FetchDetails, SetSelectedMenu }) {
  const [open, setOpen] = React.useState(0);
  const [openStatus, setOpenStatus] = React.useState(false);
  const [value, setValue] = React.useState("");
  const [category, setCategory] = React.useState("");
  const [list, setList] = React.useState([]);
  const [id, setId] = React.useState();
  const [count, setCount] = React.useState(0);
  const [deleteOpen, setDeleteOpen] = React.useState(false);
  const [openDev, setOpenDev] = React.useState(false);
  const [developers, setDevelopers] = React.useState([]);

  useEffect(() => {
    SetSelectedMenu({
      menu: "technology",
      title: "Technologies",
    });
  }, []);
  const loadDevelopers = async () => {
    const resp = await FetchDetails(`/api/technology/resource/${id}`);
    if (resp.status) {
      setDevelopers(resp.data.list);
    }
  };

  const teamItem = (resource) => {
    return (
      <div className={`mr-2 relative ${"mb-3"}`}>
        <div
          className={"absolute right-0"}
          style={{ zIndex: "10", top: "-10px" }}
        >
          {/*<Checkbox onChange={onClick} checked={checked}/>*/}
        </div>
        <CardActionArea>
          <StyledBadge
            overlap="circular"
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            // variant="dot"
          >
            <Avatar
              sx={{ bgcolor: grey[300], width: 60, height: 60 }}
              alt={resource.names}
              src={
                resource.profile
                  ? `${downloadUrl}/${resource.profile}`
                  : undefined
              }
            />
          </StyledBadge>
          <div style={{ width: "130px" }}>
            <Typography
              sx={{
                display: "-webkit-box",
                overflow: "hidden",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 1,
              }}
              variant={"body2"}
            >
              {resource.names}
            </Typography>
            <div>
              <Typography
                sx={{
                  display: "-webkit-box",
                  overflow: "hidden",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 1,
                }}
                variant={"subtitle2"}
                style={{ fontWeight: "bold" }}
              >
                {resource.category}
              </Typography>
            </div>
          </div>
        </CardActionArea>
      </div>
    );
  };

  useEffect(() => {
    if (id && openDev) {
      loadDevelopers().then();
    }
  }, [id, openDev]);

  const columns = [
    {
      name: "name",
      label: "Title",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "category",
      label: "Category",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "id",
      data: "developers",
      label: "Developers",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (v) => {
          const obj = list.find((it) => it.id === v);
          return (
            <Chip
              onClick={() => {
                setOpenDev(true);
                setId(v);
              }}
              label={obj?.developers?.toLocaleString()}
            />
          );
        },
      },
    },
    {
      name: "id",
      data: "status",
      label: "Verified",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (v) => {
          const obj = list.find((it) => it.id === v);
          return (
            <Switch
              checked={obj?.status === true}
              onChange={() => {
                setId(v);
                setOpenStatus(true);
              }}
            />
          );
        },
      },
    },
    {
      name: "id",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (v) => (
          <BasicMenu
            onDelete={() => {
              setDeleteOpen(true);
              setId(v);
            }}
            onEdit={() => {
              setOpen(2);
              const obj = list.find((vx) => vx.id === v);
              setId(v);
              setValue(obj.name);
              setCategory(obj.category);
            }}
          />
        ),
      },
    },
  ];

  const onSuccess = () => setCount((v) => v + 1);

  return (
    <div className="w-full mb-12 px-4">
      <Dialog open={openDev} onClose={() => setOpenDev(false)}>
        <DialogTitle>
          <b>{list.find((it) => it.id === id)?.name}</b> Developers(
          {developers.length})
        </DialogTitle>
        <DialogContent>
          <div className={"flex flex-wrap text-center"}>
            {developers.map((v) => teamItem(v.Resource))}
          </div>
        </DialogContent>
      </Dialog>
      <DeleteDialog
        open={deleteOpen}
        setOpen={() => setDeleteOpen(false)}
        onSuccess={onSuccess}
        url={`/api/technology/delete/${id}`}
      />
      <DeleteDialog
        open={openStatus}
        info={true}
        setOpen={() => setOpenStatus(false)}
        title={"Change Status"}
        bodyText={"Change status of this technology ?"}
        onSuccess={onSuccess}
        url={`/api/technology/change/status/${id}`}
      />
      <FormDialog
        open={open > 0}
        onSuccess={onSuccess}
        setOpen={setOpen}
        url={
          open === 1 ? "/api/technology/create" : `/api/technology/update/${id}`
        }
        title={open === 1 ? "Create New Technology" : "Edit Technology"}
        fields={[
          {
            name: "name",
            label: "Technology name",
            value,
            required: true,
            setValue,
          },
          {
            name: "category",
            label: "Category",
            value: category,
            values: [
              {
                label: "Frontend",
                value: "Frontend",
              },
              {
                label: "Backend",
                value: "Backend",
              },
              {
                label: "Database",
                value: "Database",
              },
              {
                label: "Network",
                value: "Network",
              },
              {
                label: "Mobile",
                value: "Mobile",
              },
              {
                label: "Security",
                value: "Security",
              },
              {
                label: "Project Management",
                value: "Project Management",
              },
            ],
            type: "select",
            // required:true,
            setValue: setCategory,
          },
        ]}
      />
      <DatatableComponent
        onAddNew={() => setOpen(1)}
        processData={(data) => {
          setList(data.data);
          return data;
        }}
        elevation={1}
        columns={columns}
        url={`/api/technology/list?count=${count}`}
        title={"Technologies List"}
      />
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Technology);
